(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('CrmOutboundReferralStatusDialogController', CrmOutboundReferralStatusDialogController);

    CrmOutboundReferralStatusDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'CrmOutboundReferralStatus', 'Corporation'];

    function CrmOutboundReferralStatusDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, CrmOutboundReferralStatus, Corporation) {
        var vm = this;

        vm.crmOutboundReferralStatus = entity;
        vm.clear = clear;
        vm.save = save;
        vm.corporations = Corporation.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.crmOutboundReferralStatus.id !== null) {
                CrmOutboundReferralStatus.update(vm.crmOutboundReferralStatus, onSaveSuccess, onSaveError);
            } else {
                CrmOutboundReferralStatus.save(vm.crmOutboundReferralStatus, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('bluebookApp:crmOutboundReferralStatusUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();
